









import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component
export default class EnvironmentBanner extends Vue {
    @Prop({ required: true, default: "" })
    bannerText!: string;

    get showBanner(): boolean {
        if (this.bannerText != "") {
            return true;
        }
        return false;
    }
}
